import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";
import React from "react";

export type BadgeSelectorProps = {
  values: any[];
  onChange: (values: any[]) => void;
  item: any;
};

export const BadgeSelector = ({
  item,
  values,
  onChange,
}: BadgeSelectorProps) => {
  const isSelected = React.useMemo(() => {
    return values.map((g: any) => g.id)?.includes(item.id);
  }, [values]);

  return (
    <Badge
      className={cn(
        "cursor-pointer p-2",
        isSelected ? "text-background bg-foreground" : "",
      )}
      onClick={() => {
        let newValues = values ?? [];
        if (isSelected) {
          newValues = newValues.filter((i: any) => i.id !== item.id);
        } else {
          newValues.push(item);
        }
        onChange(newValues);
      }}
      variant={"outline"}
    >
      {item.name}
    </Badge>
  );
};
